import { createPortal } from 'react-dom';

import Modal from 'components/partials/modal/modal';
import Button from 'components/partials/button/button';

interface DiscardConfirmModalProps {
  open: boolean;
  navigateToPath?: string | null;
  onContinueEditing: () => void;
  onLeaveSetup: () => void;
}

const DiscardConfirmModal = ({
  open,
  navigateToPath = null,
  onContinueEditing,
  onLeaveSetup,
}: DiscardConfirmModalProps) => {
  if (!open) return null;

  const container = document.getElementById('modal-container');

  if (!container) return null;

  const handleLeaveSetup = () => {
    const path = navigateToPath;

    onLeaveSetup?.();

    if (path) {
      window.location.assign(path);
    }
  };

  return createPortal(
    <Modal
      headerText="Are you sure you want to cancel adding this insight?"
      headerSubtext="This action will close 'New insight' modal and permanently delete your additions."
      onCloseCallback={onContinueEditing}
      skipUnmountOnClose
      modalClassName="w-[500px]"
      containerClassName="!z-[10001]"
      footer={
        <div className="flex justify-end gap-2">
          <Button
            type="button"
            variant="reserve-outlined"
            size="sm"
            onClick={onContinueEditing}
            data-testid="discard-confirm-cancel-button"
          >
            Continue editing
          </Button>
          <Button
            type="button"
            variant="brand-filled"
            size="sm"
            onClick={handleLeaveSetup}
            data-testid="discard-confirm-close-button"
          >
            Leave setup
          </Button>
        </div>
      }
      data-testid="discard-insight-confirm-modal"
    />,
    container
  );
};

export default DiscardConfirmModal;
